import { ReactNode } from 'react'

interface AcademyHighlightProps {
  children?: ReactNode
}

export const AcademyHighlight = ({ children }: AcademyHighlightProps) => {
  return (
    <span className="bg-academy-blue-500 inline-block border-2 border-base-dark px-6 py-1 font-medium leading-none text-white">
      {children}
    </span>
  )
}
